export default "__VITE_ASSET__6dc6f71c__"